import { render, staticRenderFns } from "./SendAccountDetail.vue?vue&type=template&id=5609fac0&scoped=true"
import script from "./SendAccountDetail.vue?vue&type=script&lang=js"
export * from "./SendAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./SendAccountDetail.vue?vue&type=style&index=0&id=5609fac0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5609fac0",
  null
  
)

export default component.exports